// Helper function to get comp marker icon based on score
function getCompMarkerIcon(comp) {
    // Check if pivot exists, if not return default marker
    if (!comp || !comp.pivot) {
        return '/img/map/marker-comp-unresearched.png';
    }

    let favorited = (comp.pivot.is_favorite) ? "-favorite" : "";

    if (comp.pivot.score == 0 && !comp.isRejected) {
        return '/img/map/marker-comp-unresearched' + favorited + '.png';
    } else if (comp.pivot.is_rejected) {
        return '/img/map/marker-comp-rejected' + favorited + '.png';
    } else if (comp.pivot.score < 70) {
        return '/img/map/marker-comp-rejected' + favorited + '.png';
    } else {
        if (comp.pivot.score >= 90)
            return '/img/map/marker-comp-a' + favorited + '.png';
        else
            return '/img/map/marker-comp-b' + favorited + '.png';
    }
}

export default {
    state: {
        map: null,
        mapLoading: true,
        layerLoading: false,
        markers: [],
        filteredMarkers: [],
        circles: [],
        polygons: [],
        shapes: [],
        airports: [],
        ports: [],
        states: [],
        featureData: null,
        allHighwaysData: { type: 'FeatureCollection', features: [] },
        loadedHighwayStates: {},
        infoWindow: null,
        drawingManager: null,
        stateGeoJSON: null,
        fillOpacity: 0.7,
        strokeWeight: 0.7,
        heatMap: null,

        // Popup state — replaces infoWindow HTML bubbles
        activePopup: {
            type: null,
            data: null,
        },
        heatMapMetrics: {
            11: "Income (Median)",
            3: "Population",
            1: 'Age (Median)',
            4: 'Rent (Median)',
            9: 'Education (Highschool)',
            10: 'Education (Some College)',
            7: 'Education (Bachelors)',
        },
        layout: null,
        isNegotiationMode: false,
        sites: {
            all: [],
            filtered: []
        },
        selectedSite: {},
        selectedComp: {},
        employees: [],
        customers: [],
        layers: {
            traffic: {
                label: "Traffic",
                icon: '/img/map/traffic-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 3,
                hide: false,
                on: (state, store) => {
                    state.layers.traffic.isOn = true;
                    // state.layers.transit.off(state);
                    // state.layers.bicycling.off(state);

                    state.layers.traffic.layer = new google.maps.TrafficLayer();
                    state.layers.traffic.layer.setMap(state.map);

                    document.getElementsByClassName('traffic_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.traffic.isOn = false;
                    document.getElementsByClassName('traffic_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');

                    if (state.layers.traffic.layer) {
                        state.layers.traffic.layer.setMap(null);
                    }
                }
            },
            travel_time: {
                label: "Travel Time",
                icon: '/img/map/travel-time.png',
                layer: null,
                isOn: false,
                sortOrder: 4,
                hide: false,
                parameters: {
                    arrive_or_depart: 'depart',
                    arrive_or_depart_time: '7',
                    travel_type: 'driving', // walking, public_transport, driving, cycling
                    travel_time: 1800,
                    building_id: ''
                },
                on: (state, store) => {
                    if (state.featureData) {
                        state.layers.travel_time.parameters.building_id = state.featureData.building_id ? state.featureData.building_id : state.featureData.id;
                    }

                    // document.getElementById('travel-time-container').classList.remove('hidden');
                    document.getElementsByClassName('travel_time_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');

                    state.layers.travel_time.isOn = true;

                    if (store.getters.selectedBuilding) {
                        store.dispatch('fetchTravelTime');
                    }
                },
                off: (state, store) => {
                    store.dispatch('removePolygonsByType', 'travel_time');

                    // document.getElementById('travel-time-container').classList.add('hidden');
                    document.getElementsByClassName('travel_time_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');

                    state.layers.travel_time.isOn = false;
                }
            },
            transit: {
                label: "Transit",
                icon: '/img/map/transit-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 5,
                hide: false,
                on: (state, store) => {
                    state.layers.transit.isOn = true;

                    state.layers.transit.layer = new google.maps.TransitLayer();
                    state.layers.transit.layer.setMap(state.map);

                    // Apply dark mode compatible styles for transit layer
                    const isDarkMode = document.documentElement.classList.contains('dark') ||
                        document.body.classList.contains('dark') ||
                        document.documentElement.getAttribute('data-theme') === 'dark';

                    if (isDarkMode && state.map.getMapTypeId() !== 'satellite') {
                        // Ensure transit lines are visible in dark mode by adjusting map styles
                        // Transit layer visibility is controlled by Google Maps, but we can ensure
                        // the base map doesn't interfere
                        const currentStyles = state.map.get('styles') || [];
                        const transitFriendlyStyles = currentStyles.filter(style => {
                            // Keep existing styles but ensure transit elements aren't hidden
                            return !style.featureType || !style.featureType.includes('transit');
                        });
                        state.map.setOptions({ styles: transitFriendlyStyles });
                    }

                    document.getElementsByClassName('transit_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.transit.isOn = false;

                    if (state.layers.transit.layer) {
                        state.layers.transit.layer.setMap(null);

                        document.getElementsByClassName('transit_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                }
            },
            bicycling: {
                label: "Bicycling",
                icon: '/img/map/bicycling-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 6,
                hide: true,
                on: (state, store) => {
                    state.layers.bicycling.isOn = true;
                    // state.layers.traffic.off(state);
                    // state.layers.transit.off(state);

                    state.layers.bicycling.layer = new google.maps.BicyclingLayer();
                    state.layers.bicycling.layer.setMap(state.map);

                    document.getElementsByClassName('bicycling_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.bicycling.isOn = false;

                    if (state.layers.bicycling.layer) {
                        state.layers.bicycling.layer.setMap(null);

                        document.getElementsByClassName('bicycling_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                }
            },
            team: {
                label: "Team",
                icon: '/img/map/employees-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 8,
                hide: false,
                on: (state, store) => {
                    store.dispatch('loadEmployees').then(() => {
                        store.dispatch('addMarkers', { data: store.getters.employees, type: 'employee' });
                    });

                    state.layers.team.isOn = true;

                    document.getElementsByClassName('team_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.team.isOn = false;

                    store.dispatch('removeMarkersByType', 'employee');

                    document.getElementsByClassName('team_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
            customers: {
                label: "Customers",
                icon: '/img/map/customer-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 9,
                hide: false,
                on: (state, store) => {
                    store.dispatch('loadCustomers').then(() => {
                        store.dispatch('addMarkers', { data: store.getters.customers, type: 'customer' });
                    });

                    state.layers.customers.isOn = true;

                    document.getElementsByClassName('customers_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.customers.isOn = false;

                    store.dispatch('removeMarkersByType', 'customer');

                    document.getElementsByClassName('customers_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
            heat_map: {
                label: "Heatmap",
                icon: '/img/map/heatmap-icon.png',
                layer: null,
                sortOrder: 9,
                hide: true,
                parameters: {
                    metric: 11
                },
                isOn: false,
                on: (state, store) => {
                    store.dispatch('loadHeatMapData');

                    document.getElementsByClassName('heat_map_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');

                    state.layers.heat_map.isOn = true;
                },
                off: (state, store) => {
                    state.heatMap.setMap(null);

                    document.getElementsByClassName('heat_map_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');

                    state.layers.heat_map.isOn = false;
                }
            },
            protests: {
                label: "Protests",
                icon: "/img/map/protest.png",
                isOn: false,
                clickListener: null,
                on: (state, store) => {
                    store.dispatch('loadProtests');
                    state.layers.protests.isOn = true;
                    document.getElementsByClassName('protest_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    if (state.layers.protests.clickListener) {
                        google.maps.event.removeListener(state.layers.protests.clickListener);
                        state.layers.protests.clickListener = null;
                    }
                    store.dispatch('removeDataFeaturesByType', 'protest');
                    state.layers.protests.isOn = false;
                    document.getElementsByClassName('protest_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
            cresiteiq: {
                label: "CRESiteIQ\u2122",
                icon: '/img/map/cresiteiq-icon.jpg',
                layer: null,
                isOn: false,
                sortOrder: 11,
                hide: false,
                on: async (state, store) => {
                    document.getElementsByClassName('cresiteiq_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');

                    state.layers.cresiteiq.isOn = true;

                    store.dispatch('showCRESiteIQWindow');
                    store.dispatch('loadCRESiteIQData');
                },
                off: (state, store) => {
                    state.infoWindow.close();
                    store.dispatch('clearDataLayer');

                    document.getElementsByClassName('cresiteiq_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');

                    state.layers.cresiteiq.isOn = false;

                    store.dispatch('hideCRESiteIQWindow');
                }
            },
            airports: {
                label: "Airports",
                icon: '/img/theme/v1/icons/airplane.svg',
                layer: null,
                isOn: false,
                sortOrder: 12,
                hide: false,
                showFilters: false,
                minimumAirportLength: 4000,
                minimumAirportWidth: 150,
                on: (state, store) => {
                    store.dispatch('loadAirports').then(() => {
                        store.dispatch('addMarkers', { data: store.getters.filteredAirports, type: 'airport' });
                    });

                    state.layers.airports.isOn = true;

                    document.getElementsByClassName('airport_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.airports.isOn = false;
                    state.layers.airports.showFilters = false;
                    console.log('removing airports');
                    store.dispatch('removeMarkersByType', 'airport');

                    if (state.layers.airports.layer) {
                        document.getElementsByClassName('airport_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                }
            },
            ports: {
                label: "Ports",
                icon: '/img/map/ports-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 13,
                hide: false,
                on: (state, store) => {
                    store.dispatch('loadPorts').then(() => {
                        store.dispatch('addMarkers', { data: store.getters.ports, type: 'port' });
                    });

                    state.layers.ports.isOn = true;

                    document.getElementsByClassName('port_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.ports.isOn = false;

                    store.dispatch('removeMarkersByType', 'port');

                    if (state.layers.ports.layer) {
                        document.getElementsByClassName('port_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                }
            },
            rail: {
                label: "Rail",
                icon: '/img/map/rail-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 15,
                hide: false,
                color: "#b45309",
                strokeWeight: 3,
                on: (state, store) => {
                    store.dispatch('loadRail');

                    state.layers.rail.isOn = true;

                    document.getElementsByClassName('rail_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.rail.isOn = false;

                    store.dispatch('removeDataFeaturesByType', 'rail');

                    if (state.layers.rail.layer) {
                        document.getElementsByClassName('rail_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                }
            },
            waterways: {
                label: "Waterways",
                icon: '/img/map/waterway-icon.png',
                layer: null,
                isOn: false,
                sortOrder: 16,
                hide: false,
                color: "#2563eb",
                strokeWeight: 3,
                on: (state, store) => {
                    store.dispatch('loadWaterways');

                    state.layers.waterways.isOn = true;

                    document.getElementsByClassName('waterways_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.waterways.isOn = false;

                    store.dispatch('removeDataFeaturesByType', 'waterway');

                    if (state.layers.waterways.layer) {
                        document.getElementsByClassName('waterways_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                }
            },
            highways: {
                label: "Highways",
                icon: '/img/map/highway-icon.png',
                layer: null,
                color: "#6366f1",
                strokeWeight: 3,
                isOn: false,
                sortOrder: 14,
                hide: false,
                showStateSelector: false,
                selectedStates: [],
                on: (state, store) => {
                    state.layers.highways.isOn = true;
                    state.layers.highways.showStateSelector = true;
                    document.getElementsByClassName('highway_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.highways.isOn = false;
                    state.layers.highways.showStateSelector = false;
                    state.layers.highways.selectedStates = [];
                    state.allHighwaysData = { type: 'FeatureCollection', features: [] };
                    store.commit('clearLoadedHighwayStates');

                    store.dispatch('removeDataFeaturesByType', 'highway');

                    document.getElementsByClassName('highway_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
            street_view: {
                label: "Street View",
                icon: "/img/map/street-view-icon.png",
                layer: null,
                isOn: false,
                sortOrder: 2,
                hide: true,
                on: async (state, store) => {
                    // Determine the position for Street View
                    let position = null;
                    if (state.featureData) {
                        if (
                            state.featureData.building &&
                            state.featureData.building.latitude &&
                            state.featureData.building.longitude
                        ) {
                            position = {
                                lat: parseFloat(
                                    state.featureData.building.latitude
                                ),
                                lng: parseFloat(
                                    state.featureData.building.longitude
                                ),
                            };
                        } else if (
                            state.featureData.latitude &&
                            state.featureData.longitude
                        ) {
                            position = {
                                lat: parseFloat(state.featureData.latitude),
                                lng: parseFloat(state.featureData.longitude),
                            };
                        }
                    }
                    if (!position) {
                        position = state.map.getCenter();
                    }

                    let mapDiv = document.getElementById("map");
                    let svDiv = document.getElementById("street-view");
                    if (!svDiv) {
                        svDiv = document.createElement("div");
                        svDiv.id = "street-view";
                        svDiv.style.position = "absolute";
                        svDiv.style.top = "0";
                        svDiv.style.left = "0";
                        svDiv.style.width = "100%";
                        svDiv.style.height = "100%";
                        svDiv.style.zIndex = "1000";
                        mapDiv.parentNode.insertBefore(svDiv, mapDiv);
                    }
                    mapDiv.style.display = "none";
                    svDiv.style.display = "block";

                    // Use StreetViewService to check for panorama availability
                    const svService = new google.maps.StreetViewService();
                    svService.getPanorama({ location: position, radius: 50 }, (data, status) => {
                        if (status === google.maps.StreetViewStatus.OK) {
                            // Create StreetViewPanorama if not already
                            if (!state.streetViewPanorama) {
                                google.maps.importLibrary("streetView").then(({ StreetViewPanorama }) => {
                                    state.streetViewPanorama =
                                        new StreetViewPanorama(svDiv, {
                                            position: position,
                                            pov: { heading: 165, pitch: 0 },
                                            zoom: 1,
                                        });
                                });
                            } else {
                                state.streetViewPanorama.setPosition(position);
                                state.streetViewPanorama.setVisible(true);
                            }
                            svDiv.innerHTML = ""; // Clear any previous error message
                        } else {
                            // No panorama available, show message
                            if (state.streetViewPanorama) {
                                state.streetViewPanorama.setVisible(false);
                            }
                            svDiv.innerHTML = `
                                <div style='display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;font-size:1.5rem;color:#555;background:#f8fafc;position:relative;'>
                                    <button id="close-street-view-error" style="position:absolute;top:1rem;right:1rem;background:#fff;border:none;border-radius:50%;width:2.5rem;height:2.5rem;box-shadow:0 1px 4px rgba(0,0,0,0.08);cursor:pointer;display:flex;align-items:center;justify-content:center;">
                                        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M6 18L18 6M6 6l12 12'/></svg>
                                    </button>
                                    <span>No 360° Street View imagery available for this location.</span>
                                </div>
                            `;
                            // Add close button handler
                            setTimeout(() => {
                                const closeBtn = document.getElementById('close-street-view-error');
                                if (closeBtn) {
                                    closeBtn.onclick = () => {
                                        // Call the off method for street_view
                                        state.layers.street_view.off(state, store);
                                    };
                                }
                            }, 0);
                        }
                    });

                    state.layers.street_view.isOn = true;
                    document
                        .getElementsByClassName("street_view_button")[0]
                        ?.classList.add(
                            "bg-blue-50",
                            "text-blue-600",
                            "font-semibold"
                        );
                },
                off: (state, store) => {
                    // Hide the street view div and show the map div
                    let mapDiv = document.getElementById("map");
                    let svDiv = document.getElementById("street-view");
                    if (svDiv) {
                        svDiv.style.display = "none";
                    }
                    mapDiv.style.display = "block";
                    if (state.streetViewPanorama) {
                        state.streetViewPanorama.setVisible(false);
                    }
                    state.layers.street_view.isOn = false;
                    document
                        .getElementsByClassName("street_view_button")[0]
                        ?.classList.remove(
                            "bg-blue-50",
                            "text-blue-600",
                            "font-semibold"
                        );
                },
            },
            satellite: {
                label: "Satellite",
                icon: "/img/map/satellite-view-icon.jpg",
                isOn: false,
                sortOrder: 1,
                hide: false,
                on: (state, store) => {
                    if (state.map) {
                        // Use hybrid mode instead of pure satellite for better overlay visibility
                        // Hybrid shows satellite imagery with road labels, providing better contrast
                        // for all custom layers (traffic, markers, polylines, polygons, etc.)
                        state.map.setMapTypeId('hybrid');
                        state.layers.satellite.isOn = true;

                        // Clear custom styles when in satellite mode to prevent conflicts
                        state.map.setOptions({ styles: [] });

                        document
                            .getElementsByClassName("satellite_button")[0]
                            ?.classList.add(
                                "bg-blue-50",
                                "text-blue-600",
                                "font-semibold"
                            );
                    }
                },
                off: (state, store) => {
                    if (state.map) {
                        state.map.setMapTypeId("roadmap");
                        state.layers.satellite.isOn = false;

                        // Restore theme-appropriate styles when exiting satellite mode
                        const isDarkMode = document.documentElement.classList.contains('dark') ||
                            document.body.classList.contains('dark') ||
                            document.documentElement.getAttribute('data-theme') === 'dark';

                        if (isDarkMode) {
                            // Import DARK_MAP_STYLES if available
                            import('../../components/theme/v1/cresiteiq2/constants.js').then(module => {
                                state.map.setOptions({ styles: module.DARK_MAP_STYLES || [] });
                            }).catch(() => {
                                state.map.setOptions({ styles: [] });
                            });
                        } else {
                            state.map.setOptions({ styles: [] });
                        }

                        document
                            .getElementsByClassName("satellite_button")[0]
                            ?.classList.remove(
                                "bg-blue-50",
                                "text-blue-600",
                                "font-semibold"
                            );
                    }
                },
            },
            elevation: {
                label: "Elevation",
                icon: "/img/map/elevation-icon.png",
                isOn: false,
                sortOrder: 16,
                hide: true,
                on: async (state, store) => {
                    if (state.map) {
                        await google.maps.importLibrary("elevation");
                        const service = new google.maps.ElevationService();
                        const center = state.map.getCenter();
                        service.getElevationForLocations({
                            locations: [center]
                        }, (results, status) => {
                            if (status === 'OK' && results[0]) {
                                const elevation = results[0].elevation.toFixed(2);
                                state.infoWindow.setContent(`<div class='p-2'><strong>Elevation:</strong> ${elevation} meters</div>`);
                                state.infoWindow.setPosition(center);
                                state.infoWindow.open(state.map);
                            } else {
                                state.infoWindow.setContent(`<div class='p-2'>Elevation data not available.</div>`);
                                state.infoWindow.setPosition(center);
                                state.infoWindow.open(state.map);
                            }
                        });
                        state.layers.elevation.isOn = true;
                        document.getElementsByClassName('elevation_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                    }
                },
                off: (state, store) => {
                    if (state.infoWindow) {
                        state.infoWindow.close();
                    }
                    state.layers.elevation.isOn = false;
                    document.getElementsByClassName('elevation_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
            directions: {
                label: "Directions",
                icon: '/img/map/directions-icon.png',
                layer: null,
                isOn: false,
                on: (state, store) => {
                    state.layers.directions.isOn = true;
                    store.dispatch('enableDirectionsMode');
                    document.getElementsByClassName('directions_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    state.layers.directions.isOn = false;
                    store.dispatch('disableDirectionsMode');
                    document.getElementsByClassName('directions_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
            wildfires: {
                label: "Wildfires",
                icon: "/img/map/wildfire-icon.png",
                isOn: false,
                sortOrder: 7,
                hide: false,
                on: async (state, store) => {
                    await store.dispatch('loadWildfires');
                    state.layers.wildfires.isOn = true;
                    document.getElementsByClassName('wildfires_button')[0]?.classList.add('bg-blue-50', 'text-blue-600', 'font-semibold');
                },
                off: (state, store) => {
                    // Remove only wildfire features
                    const featuresToRemove = [];
                    state.map.data.forEach(feature => {
                        if (feature.getProperty('type') === 'wildfire') {
                            featuresToRemove.push(feature);
                        }
                    });
                    featuresToRemove.forEach(feature => state.map.data.remove(feature));
                    state.layers.wildfires.isOn = false;
                    document.getElementsByClassName('wildfires_button')[0]?.classList.remove('bg-blue-50', 'text-blue-600', 'font-semibold');
                }
            },
        },
        directions: {
            mode: false,
            stops: [],         // [{latLng, meta}]
            directionsRenderer: null,
            clickListener: null,
            markerListeners: [],
            error: null,
        },
        protestFilters: {
            selectedFactors: [],
            searchText: '',
            dateRange: null
        },
    },

    actions: {
        reatlasLoadSites({ commit }) {
            axios.get('/api/sites').then(sites => {
                commit('reatlasSetSites', sites)
            }).catch(response => {
                console.error(response);
            });
        },

        async loadEmployees({ commit }) {
            await axios.get('/api/employees').then(employees => {
                commit('reatlasSetEmployees', employees.data);
            }).catch(response => {
                console.error(response);
            });
        },

        async loadCustomers({ commit }) {
            await axios.get('/api/customers').then(customers => {
                commit('reatlasSetCustomers', customers.data);
            }).catch(response => {
                console.error(response);
            });
        },

        async loadAirports({ commit }) {
            await axios.get('/api/airports').then(airports => {
                commit('reatlasSetAirports', airports.data);
            }).catch(response => {
                console.error(response);
            });
        },

        async loadPorts({ commit }) {
            await axios.get('/api/ports').then(ports => {
                commit('reatlasSetPorts', ports.data);
            }).catch(response => {
                console.error(response);
            });
        },

        async loadRail({ commit, state }) {
            state.mapLoading = true;

            axios.get('/api/cresiteiq2/layers/static', { params: { layer: 'rail' } })
                .then(response => {
                    const addedFeatures = state.map.data.addGeoJson(response.data);
                    addedFeatures.forEach(feature => {
                        feature.setProperty('type', 'rail');
                        feature.setProperty('color', state.layers.rail.color);
                        feature.setProperty('strokeWeight', state.layers.rail.strokeWeight);
                        feature.setProperty('visible', true);

                        state.map.data.overrideStyle(feature, {
                            strokeColor: state.layers.rail.color,
                            strokeOpacity: 1,
                            strokeWeight: state.layers.rail.strokeWeight,
                            visible: true
                        });
                    });

                    state.mapLoading = false;
                })
                .catch(err => {
                    console.error('Failed to load rail layer:', err);
                    state.mapLoading = false;
                });
        },

        async loadHighways({ state, commit, dispatch }, selectedStates) {
            //console.log('[ACTION] loadHighways triggered with:', selectedStates);
            commit('updateSelectedStates', selectedStates);

            // Always redraw with current data first. This handles deselection of states.
            dispatch('filterAndDrawHighways');

            const statesToFetch = selectedStates.filter(s => !state.loadedHighwayStates[s]);
            console.log('[ACTION] States to fetch:', statesToFetch);
            console.log('[ACTION] Already loaded states:', state.loadedHighwayStates);

            if (statesToFetch.length > 0) {
                state.mapLoading = true;
                // Sequentially fetch and process each state for progressive loading
                for (const stateCode of statesToFetch) {
                    try {
                        const url = `/api/cresiteiq2/layers/highways?state=${stateCode}`;
                        //console.log(`[ACTION] Fetching highways for ${stateCode} from ${url}`);
                        const response = await axios.get(url);
                        if (response.data && response.data.features) {
                            //console.log(`[ACTION] Successfully fetched ${response.data.features.length} features for ${stateCode}.`);
                            commit('addHighwayFeatures', response.data.features);
                            commit('addLoadedHighwayState', stateCode);
                            // After each successful fetch, redraw all selected highways
                            dispatch('filterAndDrawHighways');
                        }
                    } catch (error) {
                        console.error(`[ACTION] Error fetching highway data for ${stateCode}:`, error);
                    }
                }
                state.mapLoading = false;
            }
        },

        filterAndDrawHighways({ state }) {
            //console.log('[DRAW] filterAndDrawHighways called.');
            // First, remove all existing highway features from the map
            const featuresToRemove = [];
            state.map.data.forEach(feature => {
                if (feature.getProperty('type') === 'highway') {
                    featuresToRemove.push(feature);
                }
            });
            //console.log(`[DRAW] Removing ${featuresToRemove.length} highway features.`);
            featuresToRemove.forEach(feature => state.map.data.remove(feature));

            // Now, filter and draw highways based on all currently selected states
            const selectedStates = state.layers.highways.selectedStates;
            //console.log(`[DRAW] Drawing for selected states:`, selectedStates);
            if (state.allHighwaysData && selectedStates.length > 0) {
                const selectedStateSet = new Set(selectedStates);

                const filteredFeatures = state.allHighwaysData.features.filter(feature => {
                    const featureState = feature.properties.state;
                    return selectedStateSet.has(featureState);
                });
                //console.log(`[DRAW] Total features in store: ${state.allHighwaysData.features.length}. Filtered to ${filteredFeatures.length} features for drawing.`);

                if (filteredFeatures.length > 0) {
                    const filteredGeoJson = { type: "FeatureCollection", features: filteredFeatures };
                    const addedFeatures = state.map.data.addGeoJson(filteredGeoJson);
                    //console.log(`[DRAW] Added ${addedFeatures.length} features to the map.`);
                    // Set the 'type' property on each added feature so we can identify it later
                    addedFeatures.forEach(feature => {
                        feature.setProperty('type', 'highway');
                    });
                }
            }

            // Set style for all highway features on the map
            state.map.data.setStyle(feature => {
                if (feature.getProperty('type') === 'highway') {
                    return {
                        strokeColor: state.layers.highways.color,
                        strokeOpacity: 1,
                        strokeWeight: state.layers.highways.strokeWeight,
                    };
                }

                return null;
            });
        },

        async loadWaterways({ commit, state }) {
            state.mapLoading = true;

            axios.get('/api/cresiteiq2/layers/static', { params: { layer: 'waterways' } })
                .then(response => {
                    const addedFeatures = state.map.data.addGeoJson(response.data);
                    addedFeatures.forEach(feature => {
                        feature.setProperty('type', 'waterway');
                        feature.setProperty('color', state.layers.waterways.color);
                        feature.setProperty('strokeWeight', state.layers.rail.strokeWeight);
                        feature.setProperty('visible', true);

                        state.map.data.overrideStyle(feature, {
                            strokeColor: state.layers.waterways.color,
                            strokeOpacity: 1,
                            strokeWeight: state.layers.rail.strokeWeight,
                            visible: true
                        });
                    });

                    state.mapLoading = false;
                })
                .catch(err => {
                    console.error('Failed to load waterways layer:', err);
                    state.mapLoading = false;
                });
        },

        async loadStates({ commit }) {
            await axios.get('/api/states').then(state => {
                commit('reatlasSetStates', state.data);
            }).catch(response => {
                console.error(response);
            });
        },

        async addMarkers({ commit, dispatch }, data) {
            await _.each(data.data, (row) => {
                dispatch('addMarker', {
                    item: row,
                    type: data.type
                });
            });
        },

        async addMarker({ state, dispatch, commit }, data) {
            if (data.type == 'site') {
                var longitude = parseFloat(data.item.building.longitude);
                var latitude = parseFloat(data.item.building.latitude);
            } else {
                longitude = parseFloat(data.item.longitude);
                latitude = parseFloat(data.item.latitude);
            }

            if (longitude == null || latitude == null) return;

            // Import Marker from maps library
            const { Marker } = await google.maps.importLibrary("marker");

            // Use standard Marker API for compatibility with custom map styles (dark mode)
            let iconUrl = data.type == "projects" ? getCompMarkerIcon(data.item) : '/img/map/' + "marker-" + data.type + ".png";

            // If the marker image is marker-comp.png, treat as type 'comp' for direction logic
            let markerType = data.type;
            if (iconUrl && typeof iconUrl === 'string' && iconUrl.includes('marker-comp.png')) {
                markerType = 'comp';
            }

            let marker = {
                item: data.item,
                type: markerType,
                isInsideShape: false,
                marker: new Marker({
                    map: state.map,
                    position: { lat: latitude, lng: longitude },
                    icon: iconUrl
                }),
                radiusRings: [],
            };

            marker.marker.addListener("click", () => {
                state.featureData = data.item;

                switch (marker.type) {
                    case 'site':
                        var content = this.getters.generateSiteInfoBubble;
                        state.infoWindow.close();
                        state.infoWindow.setContent(content);
                        state.infoWindow.open({ anchor: marker.marker, map: marker.marker.map });
                        break;
                    case 'comp':
                        content = this.getters.generateCompInfoBubble;
                        state.infoWindow.close();
                        state.infoWindow.setContent(content);
                        state.infoWindow.open({ anchor: marker.marker, map: marker.marker.map });
                        break;
                    case 'employee':
                        commit('setActivePopup', { type: 'team', data: data.item });
                        break;
                    case 'customer':
                        commit('setActivePopup', { type: 'customer', data: data.item });
                        break;
                    case 'airport':
                        commit('setActivePopup', { type: 'airport', data: data.item });
                        break;
                    case 'port':
                        commit('setActivePopup', { type: 'port', data: data.item });
                        break;
                    default:
                        break;
                }

                if (this.getters.selectedBuilding) {
                    var buildingId = data.item.building ? data.item.building.id : data.item.id;
                    if (this.getters.selectedBuilding.id != buildingId) {
                        state.layers.travel_time.parameters.building_id = buildingId;
                        dispatch('fetchTravelTime');
                    }
                }
            });

            state.markers.push(marker);
            state.filteredMarkers.push(marker);
        },

        centerWithBounds({ state }) {
            if (!state.filteredMarkers || state.filteredMarkers.length === 0) {
                console.log('No markers to center on');
                return;
            }

            let bounds = new google.maps.LatLngBounds();
            let validMarkersCount = 0;

            state.filteredMarkers.forEach(marker => {
                if (marker.marker && marker.marker.position) {
                    const lat = marker.marker.position.lat();
                    const lng = marker.marker.position.lng();

                    // Only extend bounds if coordinates are valid numbers
                    if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
                        bounds.extend(marker.marker.position);
                        validMarkersCount++;
                    }
                }
            });

            // Only fit bounds if we have at least one valid marker
            if (validMarkersCount > 0 && state.map) {
                state.map.fitBounds(bounds);
            } else {
                console.log('No valid markers with coordinates to center on');
            }
        },

        panTo({ state, dispatch }, buildingId) {
            let marker = _.find(state.markers, marker => {
                if (state.layout == 'site') {
                    return marker.item.building && marker.item.building.id == buildingId;
                } else if (state.layout == 'projects') {
                    return marker.item && marker.item.id == buildingId;
                }
            });

            if (marker?.marker) {
                state.map.panTo(marker.marker.position);

                state.map.setZoom(8);

                new google.maps.event.trigger(marker.marker, 'click');
            }

            dispatch('hideBuildingsNotInBounds');

            // Scroll to top of the appropriate building list container
            const containerId = state.layout === 'site' ? 'site-card-container' : 'comp-card-container';
            const container = document.getElementById(containerId);
            if (container) {
                container.scrollTop = 0;
            }
        },

        removeMarkersByType({ state, dispatch }, type) {
            state.filteredMarkers.forEach((marker, index) => {
                console.log(marker.type);
                if (marker.type == type) {
                    marker.marker.setMap(null);
                }
            });

            state.markers = _.remove(state.markers, marker => marker.type != type);
            state.filteredMarkers = state.markers;
        },

        removeDataFeaturesByType({ state }, type) {
            state.mapLoading = true;

            setTimeout(() => {
                state.map.data.forEach(feature => {
                    if (feature.getProperty('type') == type) {
                        state.map.data.remove(feature);
                    }
                });
                state.mapLoading = false;
            }, 50);
        },

        removeCircles({ state }) {
            state.circles.forEach(circle => circle.ring.setMap(null));
            state.circles = [];
        },

        removePolygonsByType({ state }, type) {
            state.polygons.forEach((polygon, index) => {
                if (polygon.type == type) {
                    polygon.polygon.setMap(null);
                }
            });

            state.polygons = _.remove(state.polygons, (polygon) => { return polygon.type != type; });
        },



        drawCircle({ state }, data) {
            let radiusRing = new google.maps.Circle({
                strokeColor: "#2563eb",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#60a5fa",
                fillOpacity: 0.35,
                map: state.map,
                center: data.position,
                radius: data.miles * 1609 || 16090,
            });

            state.circles.push({
                type: data.type,
                marker: data.item,
                ring: radiusRing,
                miles: data.miles
            });

            radiusRing.setMap(state.map);
        },

        drawPolygon({ state }, data) {
            let polygon = new google.maps.Polygon({
                paths: data.coordinates.shell,
                strokeColor: "#FFC107",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FFC107",
                fillOpacity: 0.35,
            });

            state.polygons.push({
                type: data.type,
                polygon: polygon,
            });

            polygon.setMap(state.map);
        },

        addShape({ state, dispatch }, shape) {
            shape.id = state.shapes.length;

            if (shape.type == 'circle') {
                google.maps.event.addListener(shape.overlay, 'radius_changed', () => { dispatch('updateShape', shape); });
                google.maps.event.addListener(shape.overlay, 'center_changed', () => { dispatch('updateShape', shape); });
            } else if (shape.type == 'rectangle') {
                google.maps.event.addListener(shape.overlay, 'bounds_changed', () => { dispatch('updateShape', shape); });
            } else if (shape.type == 'polygon') {
                google.maps.event.addListener(shape.overlay.getPath(), 'set_at', () => { dispatch('updateShape', shape); });
                google.maps.event.addListener(shape.overlay.getPath(), 'insert_at', () => { dispatch('updateShape', shape); });
            }

            google.maps.event.addListener(shape.overlay, 'rightclick', () => { dispatch('removeShape', shape); });

            shape.overlay.setMap(state.map);

            state.shapes.push(shape);

            state.drawingManager.setDrawingMode(null);
        },

        async updateShape({ state, dispatch }, shape) {
            _.each(state.markers, marker => {
                marker.isInsideShape = false;
            });

            await dispatch('hideBuildingsNotInShapes');

            dispatch('syncBuildings');
        },

        async removeShape({ state, dispatch }, shape) {
            await _.each(state.markers, marker => {
                if (shape.type == 'circle' || shape.type == 'rectangle') {
                    let bounds = shape.overlay.getBounds();

                    if (bounds.contains(marker.marker.position)) {
                        marker.isInsideShape = false;
                    }
                } else if (shape.type == 'polygon') {
                    if (google.maps.geometry.poly.containsLocation(marker.marker.position, shape.overlay)) {
                        marker.isInsideShape = false;
                    }
                }
            });

            _.remove(this.shapes, row => row.id == shape.id);
            shape.overlay.setMap(null);

            dispatch('showMarkersInBounds');
        },

        async toggleLayer({ state, commit }, layerKey) {
            let layer = state.layers[layerKey];

            try {
                // Show loading overlay
                commit('setLayerLoading', true);

                if (layer.isOn) {
                    await layer.off(state, this);
                } else {
                    await layer.on(state, this);
                }

                // Hide loading overlay after a short delay
                setTimeout(() => {
                    commit('setLayerLoading', false);
                }, 500);
            } catch (error) {
                console.error('Error toggling layer:', layerKey, error);
                commit('setLayerLoading', false);
            }
        },

        fetchTravelTime({ state, dispatch }) {
            // Check if we have a building_id parameter
            const buildingId = state.layers.travel_time.parameters.building_id;

            if (!buildingId) {
                console.log('No building selected for travel time');
                return;
            }

            dispatch('removePolygonsByType', 'travel_time');

            // Find the building from markers or use selectedBuilding getter
            let latitude, longitude;

            const selectedBuilding = this.getters.selectedBuilding;

            if (selectedBuilding) {
                // Use the selectedBuilding getter result
                if (state.layout == 'site') {
                    latitude = selectedBuilding.item.building.latitude;
                    longitude = selectedBuilding.item.building.longitude;
                } else if (state.layout == 'projects') {
                    latitude = selectedBuilding.item.latitude ? selectedBuilding.item.latitude : selectedBuilding.item.building.latitude;
                    longitude = selectedBuilding.item.longitude ? selectedBuilding.item.longitude : selectedBuilding.item.building.longitude;
                }
            } else {
                // Try to find building in markers by id
                const marker = _.find(state.markers, m => {
                    const markerBuildingId = m.type === 'site' ? m.item.building_id : m.item.id;
                    return markerBuildingId == buildingId;
                });

                if (marker) {
                    const building = marker.type === 'site' ? marker.item.building : marker.item;
                    latitude = building.latitude;
                    longitude = building.longitude;
                } else {
                    console.log('Building not found in markers');
                    return;
                }
            }

            if (!latitude || !longitude) {
                console.log('Building coordinates not available');
                return;
            }

            dispatch('fetchIsochroneCoordinates', {
                travelType: state.layers.travel_time.parameters.travel_type,
                travelTimeInSeconds: state.layers.travel_time.parameters.travel_time,
                latitude: latitude,
                longitude: longitude,
                arriveOrDepart: state.layers.travel_time.parameters.arrive_or_depart,
                arriveOrDepartTime: state.layers.travel_time.parameters.arrive_or_depart_time
            });
        },

        async loadHeatMapData({ state, dispatch }) {
            if (state.heatMap != null) {
                state.heatMap.setMap(null);
            }

            axios.post('/api/map/heatmap_data', {
                'metric_id': state.layers.heat_map.parameters.metric
            }).then(async (response) => {
                await google.maps.importLibrary("visualization");

                let heatmapData = Array.from(response.data).map(row => {
                    return { location: new google.maps.LatLng(row.latitude, row.longitude) };
                });

                state.heatMap = new google.maps.visualization.HeatmapLayer({
                    // dissipating: true,
                    // dissipating: state.map.getZoom() <= 6 ? true : false,
                    data: heatmapData
                });

                google.maps.event.trigger(state.map, 'idle');
            }).finally(() => {
                state.heatMap.setMap(state.map);
            });
        },

        async getStatesWithinMapBounds({ state, dispatch }) {
            let statesInView = [];
            const bounds = state.map.getBounds();
            const ne = bounds.getNorthEast();
            const sw = bounds.getSouthWest();

            const bboxPolygon = turf.bboxPolygon([
                sw.lng(), sw.lat(),
                ne.lng(), ne.lat()
            ]);


            if (state.stateGeoJSON == null) {
                await axios.get('/api/map/us-states-geojson').then(response => {
                    state.stateGeoJSON = response.data
                });
            }

            // Iterate over each state and check if its geometry intersects with the map bounds
            let processes = state.stateGeoJSON.features.map(async row => {
                if (turf.booleanIntersects(bboxPolygon, row)) {
                    statesInView.push(row.properties.NAME); // or feature.properties.STATE_NAME
                }
            })

            return Promise.all(processes).then(() => {
                return statesInView.map(row => {
                    return _.find(state.states, ['name', row]) || { name: row };
                }).filter(Boolean); // Filter out any null/undefined values
            });
        },

        async syncBuildings({ state }) {
            state.filteredMarkers = _.map(_.filter(state.markers, marker => {
                return marker.marker.map != null;
            }), marker => marker);
        },

        hideBuildingsNotInBounds({ state, dispatch }) {
            if (state.shapes.length) {
                return;
            }

            let bounds = state.map.getBounds();

            state.filteredMarkers = _.filter(state.markers, marker => {
                if (marker.type == 'site' || marker.type == 'comp') {
                    var latLng = marker.type == 'site'
                        ? { lng: parseFloat(marker.item.building.longitude), lat: parseFloat(marker.item.building.latitude) }
                        : { lng: parseFloat(marker.item.longitude), lat: parseFloat(marker.item.latitude) }

                    return bounds.contains(new google.maps.LatLng(latLng));
                }

                return true;
            });
        },

        async hideBuildingsNotInShapes({ state, dispatch }) {
            await _.each(state.shapes, shape => {
                _.each(state.markers, marker => {
                    if (shape.type == 'circle' || shape.type == 'rectangle') {
                        var bounds = shape.overlay.getBounds();

                        if (!marker.isInsideShape && !bounds.contains(marker.marker.position)) {
                            marker.marker.setMap(null);
                        } else {
                            marker.isInsideShape = true;
                            marker.marker.setMap(state.map);
                        }
                    } else if (shape.type == 'polygon') {
                        if (!marker.isInsideShape && !google.maps.geometry.poly.containsLocation(marker.marker.position, shape.overlay)) {
                            marker.marker.setMap(null);
                        } else {
                            marker.isInsideShape = true;
                            marker.marker.setMap(state.map);
                        }
                    }
                });
            });
        },

        async showMarkersInBounds({ state, dispatch }) {
            let bounds = state.map.getBounds();

            await state.markers.forEach(marker => {
                if (bounds.contains(marker.marker.position)) {
                    marker.marker.setMap(state.map);
                }
            });

            state.filteredMarkers = state.markers;
        },

        fetchIsochroneCoordinates({ state, dispatch }, options) {
            // Apply traffic adjustment factor for driving mode to get more realistic results
            // TravelTime API tends to be optimistic with driving speeds, especially in urban areas
            // Apply 0.65x multiplier for driving to account for realistic traffic conditions
            let adjustedTravelTime = options.travelTimeInSeconds || 900;
            const travelType = options.travelType || 'driving';

            if (travelType === 'driving') {
                adjustedTravelTime = Math.round(adjustedTravelTime * 0.65);
                console.log(`[Travel Time] Applying traffic adjustment for driving: ${options.travelTimeInSeconds}s -> ${adjustedTravelTime}s`);
            }

            axios.post('/api/map/isochrone', {
                'type': travelType,
                'travel_time': adjustedTravelTime,
                'latitude': options.latitude,
                'longitude': options.longitude,
                'arrive_or_depart': options.arriveOrDepart,
                'arrive_or_depart_time': options.arriveOrDepartTime
            }).then(response => {
                // Check if response has error from TravelTime API
                if (response.data && response.data.error_code) {
                    console.error('TravelTime API error:', response.data);

                    // Handle rate limiting (429 error)
                    if (response.data.http_status === 429 || response.data.error_code === 9) {
                        window.toastr && window.toastr.error(
                            'Travel time API rate limit exceeded. Please wait a moment and try again.',
                            'Rate Limit Exceeded',
                            { timeOut: 5000 }
                        );
                    } else {
                        // Handle other API errors
                        window.toastr && window.toastr.error(
                            response.data.description || 'Unable to calculate travel time. Please try again.',
                            'Travel Time Error',
                            { timeOut: 5000 }
                        );
                    }
                    return;
                }

                // Check if response has valid data structure
                if (!response.data || !response.data.results || !response.data.results[0] || !response.data.results[0].shapes) {
                    console.error('Invalid isochrone response:', response.data);
                    window.toastr && window.toastr.error(
                        'Unable to display travel time area. Please try again.',
                        'Invalid Response',
                        { timeOut: 5000 }
                    );
                    return;
                }

                let shapes = response.data.results[0].shapes;

                shapes.forEach(shape => {
                    dispatch('drawPolygon', {
                        type: 'travel_time',
                        coordinates: {
                            shell: shape.shell,
                            holes: shape.holes
                        }
                    });
                })
            }).catch(error => {
                console.error('Error fetching isochrone coordinates:', error);
                window.toastr && window.toastr.error(
                    'Network error while calculating travel time. Please check your connection.',
                    'Network Error',
                    { timeOut: 5000 }
                );
            });
        },

        clearMap({ state }) {
            state.filteredMarkers.forEach(marker => {
                marker.isInsideShape = false;
                marker.marker.setMap(null)
            });

            state.circles.forEach(circle => circle.ring.setMap(null));
            state.circles = [];

            state.polygons.forEach(polygons => polygons.polygon.setMap(null));
            state.polygons = [];
        },

        saveMap({ state }) {
            axios.post('/reatlas', this.getters.parsedState).then(response => {
                console.log(response);
            }).catch(error => {
                console.log(error);
            })
        },

        loadMap({ state }, mapId) {
        },

        clearDataLayer({ state }) {
            state.map.data.forEach(feature => {
                state.map.data.remove(feature);
            });

            state.map.data.setMap(null);
        },

        async initDataLayerListeners(context) {
            context.state.map.data.addListener('mouseout', event => {
                if (context.state.infoWindow.getMap() == null) {
                    if (event.feature.getProperty('type') == 'area') {
                        context.state.map.data.overrideStyle(event.feature, { strokeWeight: context.state.strokeWeight });
                    }
                }
            });

            context.state.map.data.addListener('click', async event => {
                if (event.feature.getProperty('type') == 'area') {
                    context.dispatch('toggleInfoWindow', event.feature);
                }

                switch (event.feature.getProperty('type')) {
                    case 'rail': {
                        const railProps = {};
                        event.feature.forEachProperty((val, key) => { railProps[key] = val; });
                        context.commit('setActivePopup', { type: 'rail', data: { properties: railProps } });
                        break;
                    }
                    case 'waterway': {
                        const waterwayProps = {};
                        event.feature.forEachProperty((val, key) => { waterwayProps[key] = val; });
                        context.commit('setActivePopup', {
                            type: 'waterway',
                            data: {
                                name: waterwayProps.Name || 'Unknown Waterway',
                                classification: parseInt(waterwayProps.ClassWtrw) || 2,
                                length_miles: waterwayProps.MilesGeo || null,
                            }
                        });
                        break;
                    }
                    case 'highway': {
                        const highwayProps = {};
                        event.feature.forEachProperty((val, key) => { highwayProps[key] = val; });
                        context.commit('setActivePopup', { type: 'highway', data: highwayProps });
                        break;
                    }
                }
            });

            context.state.map.data.addListener('mouseover', async function (event) {
                const featureType = event.feature.getProperty('type');
                if (featureType === 'rail' || featureType === 'waterway' || featureType === 'highway') {
                    context.state.map.data.overrideStyle(event.feature, { strokeOpacity: 1.0 });
                    return;
                }
            });

            context.state.map.data.addListener('mouseout', function (event) {
                const featureType = event.feature.getProperty('type');
                if (featureType === 'rail' || featureType === 'waterway' || featureType === 'highway') {
                    context.state.map.data.revertStyle(event.feature);
                    return;
                }
                if (featureType != 'area' && featureType != 'protest') {
                    context.state.infoWindow.close();
                }
            });
        },

        generateRailInfoBubble(context, feature) {
            return `
                <div class="flex flex-col gap-y-2 px-3 py-1">
                    <h1 class="text-lg font-bold">${feature.getProperty('BRANCH')}</h1>

                    <table class="border-spacing-2">
                        <thead>
                            <tr>
                                <th class="px-2 text-center">Division</th>
                                <th class="px-2 text-center">Sub Division</th>
                                <th class="px-2 text-center">Tracks</th>
                                <th class="pr-4 text-right">Miles</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="px-2 text-center">${feature.getProperty('DIVISION') || '-'}</td>
                                <td class="px-2 text-center">${feature.getProperty('SUBDIV') || '-'}</td>
                                <td class="px-2 text-center">${feature.getProperty('TRACKS') || '-'}</td>
                                <td class="text-right">${feature.getProperty('MILES') || '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            `;
        },

        generateHighwayInfoBubble(context, feature) {
            const fields = [
                { key: "road_name", label: "Road Name" },
                { key: "class", label: "Class" },
                { key: "class_desc", label: "Class Description" },
                { key: "sign_route", label: "Sign Route" },
                { key: "sign_rte", label: "Sign Route" }, // fallback
                { key: "route_type", label: "Route Type" },
                { key: "rte_type", label: "Route Type" }, // fallback
                { key: "rte_number", label: "Route Number" },
                { key: "state", label: "State" },
                { key: 'stfips', label: 'State FIPS' },
                { key: "county_name", label: "County Name" },
                { key: 'ctfips', label: 'County FIPS' },
                { key: 'urban_code', label: 'Urban Code' },
                { key: 'func_class', label: 'Functional Class' },
                { key: 'facility_type', label: 'Facility Type' },
                { key: "speed_limit", label: "Speed Limit" },
                { key: "Urban_Rural", label: "Urban/Rural" },
                { key: "Total_Tons", label: "Total Tons", isNumeric: true },
                { key: "TOT_Tons_1", label: "Total Tons", isNumeric: true }, // fallback
                { key: "hpms_routeID", label: "Route ID" },
                { key: "hpms_usa_r", label: "Route ID" }, // fallback
                {
                    key: "GEOD_LENGTH",
                    label: "Length (Miles)",
                    isNumeric: true,
                },
                { key: "GEOD_LEN", label: "Length (Miles)", isNumeric: true }, // fallback
            ];

            const addedKeys = new Set();

            const rows = fields
                .map(({ key, label, isNumeric }) => {
                    if (addedKeys.has(label)) return null;
                    const value = feature.getProperty(key);
                    if (value !== undefined && value !== null) {
                        addedKeys.add(label);
                        const formatted = isNumeric
                            ? parseFloat(value)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : value;
                        return `
                    <tr>
                        <td class="px-2 py-1 font-medium text-gray-700">${label}</td>
                        <td class="px-2 py-1 text-right">${formatted}</td>
                    </tr>
                `;
                    }
                    return null;
                })
                .filter(Boolean)
                .join("");

            const roadName =
                feature.getProperty("road_name") ||
                feature.getProperty("sign_route") ||
                feature.getProperty("sign_rte") ||
                "Highway Info";

            return `
                <div class="flex flex-col gap-y-2 px-3 py-1">
                    <h1 class="text-lg font-bold">${roadName}</h1>
                    <table class="border-spacing-2 text-sm w-full">
                        <thead>
                            <tr>
                                <th class="text-left px-2 pb-1 text-xs text-white-500 border-b">Property</th>
                                <th class="text-right px-2 pb-1 text-xs text-white-500 border-b">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rows}
                        </tbody>
                    </table>
                </div>
            `;
        },

        generateWaterwayInfoBubble(context, feature) {
            return `
                <div class="flex flex-col gap-y-2 px-3 py-1">
                    <h1 class="text-lg font-bold">${feature.getProperty('Name')}</h1>

                    <table class="border-spacing-2">
                        <thead>
                        <tr>
                            <th class="px-2 text-center">Class</th>
                            <th class="text-right">Miles</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="px-2 text-center">${feature.getProperty('ClassWtrw') || '-'}</td>
                            <td class="pr-2 text-right">${feature.getProperty('MilesGeo') || '-'}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            `;
        },

        enableDirectionsMode({ state, dispatch }) {
            state.directions.mode = true;
            state.directions.stops = [];
            if (state.directions.directionsRenderer) {
                state.directions.directionsRenderer.setMap(null);
                state.directions.directionsRenderer = null;
            }
            if (state.directions.clickListener) {
                google.maps.event.removeListener(state.directions.clickListener);
                state.directions.clickListener = null;
            }
            state.directions.clickListener = state.map.addListener('click', (e) => {
                dispatch('setDirectionPoint', { latLng: e.latLng, markerData: null });
            });
            state.directions.markerListeners = [];
            state.markers.forEach(markerObj => {
                if (markerObj._directionListener) {
                    google.maps.event.removeListener(markerObj._directionListener);
                }
                const directionListener = markerObj.marker.addListener('click', (event) => {
                    const latLng = markerObj.marker.position;
                    let meta = {};
                    if (markerObj.item) {
                        meta = {
                            address: markerObj.item.building?.address_line_1 || markerObj.item.address_line_1 || '',
                            city: markerObj.item.building?.city || markerObj.item.city || '',
                            state: markerObj.item.building?.state || markerObj.item.state || '',
                            title: markerObj.item.building?.address_line_1 || markerObj.item.address_line_1 || '',
                        };
                    }
                    dispatch('setDirectionPoint', { latLng, markerData: meta });
                });
                markerObj._directionListener = directionListener;
                state.directions.markerListeners.push(directionListener);
            });
        },

        async setDirectionPoint({ state, dispatch }, { latLng, markerData }) {
            let stops = state.directions.stops.slice();
            // Always ensure at least 2 stops
            if (stops.length < 2) {
                stops = [{}, {}];
            }
            // If origin is not set, set it first
            if (!stops[0].latLng) {
                Object.assign(stops[0], { latLng, meta: markerData || null });
                state.directions.stops = stops;
                state.directions.error = null;
                return;
            }
            // ---- Fix: Find first empty stop after origin, fill it before appending ----
            let emptyIdx = stops.findIndex((s, idx) => idx !== 0 && (!s.latLng && (!s.text || s.text === '')));
            let newStops;
            if (emptyIdx !== -1) {
                newStops = stops.map((s, idx) => idx === emptyIdx ? { ...s, latLng, meta: markerData || null } : s);
            } else {
                // No empty stops, so append
                newStops = [...stops, { latLng, meta: markerData || null }];
            }
            // Remove any *extra* empty stops at the end (just keep one if it's last)
            while (
                newStops.length > 2 &&
                !newStops[newStops.length - 1].latLng &&
                (!newStops[newStops.length - 1].text || newStops[newStops.length - 1].text === '') &&
                !newStops[newStops.length - 2].latLng &&
                (!newStops[newStops.length - 2].text || newStops[newStops.length - 2].text === '')
            ) {
                newStops.pop();
            }

            // Update stops first, then try to fetch directions
            state.directions.stops = newStops;
            state.directions.error = null;

            // Only fetch directions if we have at least origin and destination
            if (newStops.length >= 2 && newStops[0].latLng && newStops[newStops.length - 1].latLng) {
                try {
                    await dispatch('fetchDirectionsWithWaypoints', {
                        stops: newStops,
                    });
                } catch (err) {
                    state.directions.error = 'Unable to find a route with the selected stops. Please try changing the addresses.';
                }
            }
        },
        async removeDirectionPoint({ state, dispatch }, idx) {
            // Don't allow removing origin or destination if only two stops
            if (state.directions.stops.length <= 2) return;
            if (idx === 0) return;

            // Copy and remove the stop at idx
            const stopsBefore = state.directions.stops.slice();
            const newStops = stopsBefore.filter((_, i) => i !== idx);

            // Keep at least 2 stops always
            while (newStops.length < 2) newStops.push({});

            state.directions.error = null;

            if (
                newStops.length >= 2 &&
                newStops[0].latLng &&
                newStops[newStops.length - 1].latLng
            ) {
                try {
                    await dispatch('fetchDirectionsWithWaypoints', { stops: newStops });
                    state.directions.stops = newStops;
                } catch (err) {
                    // If route fails, revert to previous state and set error
                    state.directions.error = 'Unable to find a route after removing this stop. Please try a different route.';
                    state.directions.stops = stopsBefore;
                }
            } else {
                state.directions.stops = newStops;
            }
        },
        async reorderDirectionStops({ state, dispatch }, { stops }) {

            state.directions.stops = stops;
            state.directions.error = null;
            if (
                stops.length >= 2 &&
                stops[0].latLng &&
                stops[stops.length - 1].latLng
            ) {
                try {
                    await dispatch('fetchDirectionsWithWaypoints', { stops: stops });
                } catch (err) {
                    // If route fails, revert to previous state and set error
                    state.directions.error = 'Unable to find a route after removing this stop. Please try a different route.';
                }
            }
        },
        disableDirectionsMode({ state }) {
            state.directions.mode = false;
            state.directions.stops = [];
            if (state.directions.directionsRenderer) {
                state.directions.directionsRenderer.setMap(null);
                state.directions.directionsRenderer = null;
            }
            if (state.directions.clickListener) {
                google.maps.event.removeListener(state.directions.clickListener);
                state.directions.clickListener = null;
            }
            if (state.directions.markerListeners) {
                state.directions.markerListeners.forEach(listener => {
                    google.maps.event.removeListener(listener);
                });
                state.directions.markerListeners = [];
            }
        },

        async fetchDirectionsWithWaypoints({ state }, { stops, drivingOptions = null }) {
            return new Promise((resolve, reject) => {
                if (!stops || stops.length < 2) return reject('Not enough stops');
                const origin = stops[0].latLng;
                const destination = stops[stops.length - 1].latLng;
                const waypoints = stops.slice(1, -1).filter(s => s.latLng).map(s => ({ location: s.latLng, stopover: true }));
                const directionsService = new google.maps.DirectionsService();
                if (!state.directions.directionsRenderer) {
                    state.directions.directionsRenderer = new google.maps.DirectionsRenderer();
                    state.directions.directionsRenderer.setMap(state.map);
                }

                // Build the request object
                const request = {
                    origin,
                    destination,
                    waypoints,
                    travelMode: google.maps.TravelMode.DRIVING,
                };

                // Add drivingOptions if provided
                if (drivingOptions && drivingOptions.departureTime) {
                    request.drivingOptions = {
                        departureTime: drivingOptions.departureTime,
                        trafficModel: drivingOptions.trafficModel || google.maps.TrafficModel.BEST_GUESS
                    };
                }

                directionsService.route(
                    request,
                    (result, status) => {
                        if (status === google.maps.DirectionsStatus.OK) {
                            state.directions.directionsRenderer.setDirections(result);
                            resolve(result);
                        } else {
                            reject(status);
                        }
                    }
                );
            });
        },

        async loadWildfires({ state, commit }) {
            // Remove any existing wildfire features first
            const featuresToRemove = [];
            state.map.data.forEach(feature => {
                if (feature.getProperty('type') === 'wildfire') {
                    featuresToRemove.push(feature);
                }
            });
            featuresToRemove.forEach(feature => state.map.data.remove(feature));

            // Load wildfire layer from API
            axios.get('/api/cresiteiq2/layers/static', { params: { layer: 'wildfire' } })
                .then(response => {
                    const addedFeatures = state.map.data.addGeoJson(response.data);
                    addedFeatures.forEach(feature => {
                        feature.setProperty('type', 'wildfire');
                        // Map actual property names to expected ones for info window
                        if (!feature.getProperty('acq_date') && feature.getProperty('initial_imsr_date')) {
                            feature.setProperty('acq_date', feature.getProperty('initial_imsr_date'));
                        }
                        if (!feature.getProperty('brightness') && feature.getProperty('size')) {
                            feature.setProperty('brightness', feature.getProperty('size'));
                        }
                        let confidence = feature.getProperty('confidence');
                        if (!confidence) confidence = 'N/A';
                        if (!feature.getProperty('fire_name')) {
                            feature.setProperty('fire_name', feature.getProperty('fire_name'));
                        }
                    });
                })
                .catch(err => console.error('Failed to load wildfire layer:', err));

            // Style wildfire points
            state.map.data.setStyle(feature => {
                if (feature.getProperty('type') === 'wildfire') {
                    return {
                        icon: {
                            url: '/img/map/wildfire-icon.png',
                            scaledSize: new google.maps.Size(24, 24)
                        },
                        zIndex: 1000
                    };
                }
                return null;
            });

            // Add click handler for wildfire popup
            state.map.data.addListener('click', function(event) {
                const featureType = event.feature.getProperty('type');
                if (featureType === 'wildfire') {
                    const props = {};
                    event.feature.forEachProperty((val, key) => { props[key] = val; });
                    commit('setActivePopup', {
                        type: 'wildfire',
                        data: {
                            fire_name:         props.fire_name || props.initial_imsr_name || 'Unknown',
                            initial_imsr_date: props.acq_date || props.initial_imsr_date || null,
                            size:              props.brightness || props.size || null,
                            imt_type:          props.confidence || null,
                        }
                    });
                }
            });
            // Highlight on hover
            state.map.data.addListener('mouseover', function(event) {
                if (event.feature.getProperty('type') === 'wildfire') {
                    state.map.data.overrideStyle(event.feature, { zIndex: 2000 });
                }
            });
            state.map.data.addListener('mouseout', function(event) {
                if (event.feature.getProperty('type') === 'wildfire') {
                    state.map.data.revertStyle(event.feature);
                }
            });
        },

        loadProtests({ state, commit, rootState }) {
            // Helper function to filter features based on filter criteria
            const applyProtestFilters = (state, filters = {}) => {
                const { dateRange, searchText = '', selectedFactors = [] } = filters;
                const searchTextLower = searchText.toLowerCase();

                state.map.data.forEach(feature => {
                    if (feature.getProperty('type') !== 'protest') return;

                    const events = feature.getProperty('events') || [];
                    let isVisible = true;

                    // Apply date range filter if provided
                    if (dateRange && dateRange.startDate && dateRange.endDate) {
                        // Parse filter dates from MM-DD-YYYY format
                        const parseFilterDate = (dateStr) => {
                            const [month, day, year] = dateStr.split('-').map(Number);
                            const date = new Date(year, month - 1, day);
                            return date;
                        };

                        // Create date objects for filter range
                        const startDate = parseFilterDate(dateRange.startDate);
                        const endDate = parseFilterDate(dateRange.endDate);
                        endDate.setHours(23, 59, 59, 999); // Set to end of day

                        const hasMatchingDate = events.some(event => {
                            if (!event.date) return false;

                            try {
                                // Parse DD-MM-YYYY format from event date
                                const [day, month, year] = event.date.split('-').map(Number);
                                if (!day || !month || !year) return false;

                                // Create date in local timezone for comparison
                                const eventDate = new Date(year, month - 1, day);

                                return eventDate >= startDate && eventDate <= endDate;
                            } catch (e) {
                                console.error('Error parsing event date:', e, 'Event:', event);
                                return false;
                            }
                        });

                        isVisible = isVisible && hasMatchingDate;
                    }

                    // Apply search text filter if provided
                    if (searchTextLower) {
                        const featureSearchText = (feature.getProperty('searchText') || '').toLowerCase();
                        isVisible = isVisible && featureSearchText.includes(searchTextLower);
                    }

                    // Apply selected factors filter if any factors are selected
                    if (selectedFactors.length > 0) {
                        const eventTexts = events.map(event =>
                            `${event.event_type || ''} ${event.claims_summary || ''}`.toLowerCase()
                        ).join(' ');

                        const hasMatchingFactor = selectedFactors.some(factor => {
                            // Extract just the keyword part if it contains a colon (category:keyword)
                            const keyword = factor.includes(':') ? factor.split(':')[1] : factor;
                            return eventTexts.includes(keyword.toLowerCase());
                        });

                        isVisible = isVisible && hasMatchingFactor;
                    }

                    // Update feature visibility and style
                    feature.setProperty('visible', isVisible);

                    // Set the style for the feature
                    state.map.data.overrideStyle(feature, {
                        visible: isVisible,
                        opacity: isVisible ? 1 : 0,
                        cursor: isVisible ? 'pointer' : 'default'
                    });
                });
            };

            // Expose the applyProtestFilters function globally
            window.applyProtestMapFilters = (filters) => {
                // Merge with existing filters to preserve any existing filter state
                const mergedFilters = {
                    ...rootState.protestFilters,
                    ...filters
                };

                // Update the store with the new filters
                commit('setProtestFilters', mergedFilters);

                // Apply the filters to the map
                applyProtestFilters(state, mergedFilters);
            };

            // Remove existing protest features
            let featuresToRemove = [];
            state.map.data.forEach(feature => {
                if (feature.getProperty('type') === 'protest') {
                    featuresToRemove.push(feature);
                }
            });
            featuresToRemove.forEach(feature => state.map.data.remove(feature));

            // Load protests layer from API
            axios.get('/api/cresiteiq2/layers/static', { params: { layer: 'protests' } })
                .then(response => {
                    const addedFeatures = state.map.data.addGeoJson(response.data);
                    addedFeatures.forEach(feature => {
                        feature.setProperty('type', 'protest');
                        // Add searchable text to each feature for filtering
                        const events = feature.getProperty('events') || [];
                        const searchText = events
                            .map(event => {
                                const date = event.date || '';
                                const eventType = event.event_type || '';
                                const claims = event.claims_summary || '';
                                return `${date} ${eventType} ${claims}`.toLowerCase();
                            })
                            .join(' ');
                        feature.setProperty('searchText', searchText);
                    });

                    // Apply initial filters
                    applyProtestFilters(state, rootState.protestFilters);
                })
                .catch(err => console.error('Failed to load protests layer:', err));

            // Style protest points
            state.map.data.setStyle(feature => {
                if (feature.getProperty('type') === 'protest') {
                    return {
                        icon: {
                            url: '/img/map/protest.png',
                            scaledSize: new google.maps.Size(32, 32)
                        },
                        zIndex: 1000
                    };
                }
                return null;
            });
            // Add info window for protest points on click
            state.layers.protests.clickListener = state.map.data.addListener('click', function (event) {
                const featureType = event.feature.getProperty('type');
                if (featureType === 'protest') {
                    const events = event.feature.getProperty('events') || [];
                    commit('setActivePopup', {
                        type: 'protest',
                        data: { events }
                    });
                }
            });
        },

    },

    mutations: {
        setLayerLoading(state, isLoading) {
            state.layerLoading = isLoading;
        },

        setActivePopup(state, { type, data }) {
            state.activePopup = { type, data };
        },

        clearActivePopup(state) {
            state.activePopup = { type: null, data: null };
        },

        setProtestFilters(state, filters) {
            state.protestFilters = {
                ...state.protestFilters,
                ...filters
            };
        },
        reatlasSetSites(state, sites) {
            state.sites.all = sites.data
            state.sites.filtered = sites.data
        },

        reatlasSetEmployees(state, employees) {
            state.employees = employees;
        },

        reatlasSetCustomers(state, customers) {
            state.customers = customers;
        },

        reatlasSetAirports(state, airports) {
            state.airports = airports;
        },

        setTeam(state, team) {
            state.team = team;
        },

        updateSelectedStates(state, selectedStates) {
            console.log("Committing updateSelectedStates with:", selectedStates);
            if (Array.isArray(selectedStates)) {
                state.layers.highways.selectedStates = selectedStates.filter(s => s); // Filter out empty strings
            }
        },

        addLoadedHighwayState(state, stateCode) {
            state.loadedHighwayStates = { ...state.loadedHighwayStates, [stateCode]: true };
        },

        clearLoadedHighwayStates(state) {
            state.loadedHighwayStates = {};
        },

        addHighwayFeatures(state, features) {
            state.allHighwaysData = {
                ...state.allHighwaysData,
                features: [...state.allHighwaysData.features, ...features],
            };
        },

        reatlasSetStates(state, states) {
            state.states = states;
        },

        reatlasSetPorts(state, ports) {
            state.ports = ports;
        },
    },

    getters: {
        parsedState: (state) => {
            var stateClone = _.cloneDeep(state);

            // we don't need to save google's tool objects
            stateClone = _.omit(stateClone, ['map', 'drawingManager', 'infoWindow', 'sites']);

            _.each(stateClone, (obj, key) => {
                // we have to remove google's 'marker' object from each marker
                if (['markers', 'filteredMarkers'].includes(key)) {
                    obj.forEach((marker, key) => { obj[key] = _.omit(marker, ['marker']) });
                }

                // we have to remove google's 'ring' object from each circle
                if (['circles'].includes(key)) {
                    obj.forEach((circle, key) => { obj[key] = _.omit(circle, ['ring']) });
                }
            });

            return { ...stateClone };
        },

        reatlasSitesSortedBy: (state) => (fields) => {
            return _.sortBy(state.sites.all, fields);
        },

        addedMarkers: (state) => {
            return Array.from(state.markers);
        },

        airports(state) {
            return state.airports;
        },

        filteredAirports(state) {
            return _.filter(state.airports, airport => {
                return airport.min_runway_length >= state.layers.airports.minimumAirportLength
                    && airport.min_runway_width >= state.layers.airports.minimumAirportWidth;
            });
        },

        ports(state) {
            return state.ports;
        },

        employees(state) {
            return state.employees;
        },

        customers(state) {
            return state.customers;
        },

        selectedBuilding(state) {
            return _.find(state.markers, marker => {
                if (state.layout == 'site') {
                    var buildingId = marker.item.building_id;
                } else if (state.layout == 'projects') {
                    buildingId = marker.item.id;
                }

                return buildingId == state.layers.travel_time.parameters.building_id;
            });
        },

        generateSiteInfoBubble(state) {
            const siteSize = state.featureData.size ? state.featureData.size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-';
            const currentPsf = state.featureData.current_psf_formatted || '-';

            let html = `
                <div class="reatlas-info-window">
                    <div class="reatlas-info-window__content">
                        <h3 class="reatlas-info-window__title">${state.featureData.building.address_line_1}</h3>
                        <p class="reatlas-info-window__location">${state.featureData.building.city}, ${state.featureData.building.state}</p>
                        <p class="reatlas-info-window__details">${currentPsf} PSF | ${siteSize} SF</p>
                    </div>
                </div>
            `;

            return html;
        },

        generateCompInfoBubble(state) {
            const siteSize = state.featureData.total_square_footage ? state.featureData.total_square_footage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-';
            const currentPsf = state.featureData.pivot?.ask_price_formatted || state.featureData.pivot?.ask_price || '-';

            let html = `
                <div class="reatlas-info-window">
                    <div class="reatlas-info-window__content">
                        <h3 class="reatlas-info-window__title">${state.isNegotiationMode ? 'Alternative Site' : state.featureData.address_line_1}</h3>
                        <p class="reatlas-info-window__location">${state.featureData.city}, ${state.featureData.state}</p>
                        <p class="reatlas-info-window__details">${currentPsf} PSF | ${siteSize} SF</p>
                    </div>
                </div>
            `;

            return html;
        },

        generateCustomerInfoBubble(state) {
            return `
                <div class="reatlas-info-window">
                    <div class="reatlas-info-window__content">
                        <h3 class="reatlas-info-window__title">${state.featureData.name}</h3>
                        <p class="reatlas-info-window__location">${state.featureData.address}</p>
                        <p class="reatlas-info-window__details">${state.featureData.city}, ${state.featureData.state}</p>
                    </div>
                </div>
            `;
        },

        generateAirportInfoBubble(state) {
            return `
                <div class="reatlas-info-window">
                    <div class="reatlas-info-window__content">
                        <h3 class="reatlas-info-window__title">${state.featureData.name} (${state.featureData.iata_code})</h3>
                        <p class="reatlas-info-window__location">Airport</p>
                        <p class="reatlas-info-window__details">${state.featureData.runways ? state.featureData.runways.length : 0} Runways</p>
                    </div>
                </div>
            `;
        },

        generatePortInfoBubble(state) {
            return `
    < div class='p-3 bg-white shadow-md rounded z-50' >
				    <div class="flex justify-between">
					    <h1 class="text-lg font-bold">${state.featureData.name}</h1>
                        <button onclick="closeInfoBubble()">
                            <svg class="w-5 h-5 text-gray-500 hover:text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

					<h3 class="mt-2 text-base text-gray-700">Rank: #${state.featureData.rank}</h3>

					<table class="mt-2 border shadow-md">
						<thead>
							<tr class="bg-gray-800 text-white">
								<th class="py-2 px-4">Domestic</th>
								<th class="py-2 px-4">Foreign</th>
								<th class="py-2 px-4">Total</th>
								<th class="py-2 px-4">Foreign Imports</th>
								<th class="py-2 px-4">Foreign Exports</th>
							</tr>
						</thead>
						<tbody>

                            <tr>
                                <td class="p-4 border text-center">${state.featureData.shortened_total_domestic}</td>
                                <td class="p-4 border text-center">${state.featureData.shortened_total_foreign}</td>
                                <td class="p-4 border text-center">${state.featureData.shortened_total_trade}</td>
                                <td class="p-4 border text-center">${state.featureData.shortened_foreign_imports}</td>
                                <td class="p-4 border text-center">${state.featureData.shortened_foreign_exports}</td>
                            </tr>
						</tbody>
					</table>
				</div >
    `;
        },
    },
};

// Shared utility to calculate route details from Google Directions result
export function getRouteDetails(directions) {
    if (!directions || !directions.routes || !directions.routes[0]) return null;
    let totalDistance = 0, totalDuration = 0;
    directions.routes[0].legs.forEach(leg => {
        totalDistance += leg.distance.value; // meters
        totalDuration += leg.duration.value; // seconds
    });
    const distanceMiles = totalDistance / 1609.344;
    // Format distance in miles (2 decimals)
    const distanceMilesFormatted = distanceMiles.toFixed(2) + ' miles';

    // Format duration as hours and minutes
    const totalMinutes = Math.round(totalDuration / 60);
    let durationFormatted = '';
    if (totalMinutes >= 60) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) {
            durationFormatted = `${hours} hour${hours > 1 ? 's' : ''} `;
        } else {
            durationFormatted = `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes > 1 ? 's' : ''} `;
        }
    } else {
        durationFormatted = `${totalMinutes} minute${totalMinutes !== 1 ? 's' : ''} `;
    }

    return {
        distance_miles: distanceMiles, // raw miles as a number
        distance: distanceMilesFormatted, // formatted string
        duration_minutes: totalMinutes, // raw minutes as a number
        duration: durationFormatted // formatted string
    };
}

